/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { withLocalize } from "react-localize-redux";
import { isEmpty, get, map } from "lodash";
import Drawer from "@material-ui/core/Drawer";
import Close from "@material-ui/icons/Close";
import { applySubscription, createAddress } from "../Shared/helpers";
import { decode } from "../Shared/encode";
import ErrorModal from "../../Shared/ErrorModal";
import { defaultErrorMessage } from "../../../constants";
import { setAlreadyShownSoothePassPopup } from "../../../Actions";
import { ADDITIONAL_INFO } from "../Shared/constants";
import {
  seMembershipContinue,
  seMembershipSkip,
  seMembershipUpsellView,
  seMembershipView,
  seViewSoothePassFAQ,
} from "../../Shared/WebAnalytics";
import { soothe_pass_subscriptions } from "../../Shared/Helpers";
import { createCart } from "../Shared/helpers";
import { setCart } from "../../../Actions/CartAction";
import "./SubscriptionPlanPopup.css";
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

class SubscriptionPlanPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openedIndex: null,
      error: "",
      showErrorModal: false,
      width: window.innerWidth,
      showSmallSizeModal: get(props, "withoutToaster", false),
      subscriptionPlans: [],
      selectedTier: null,
      loadingPlans: false,
      showPlanSelection: false,
    };
    this.popupHeader = this.popupHeader.bind(this);
    this.additionalInfo = this.additionalInfo.bind(this);
    this.popupFooter = this.popupFooter.bind(this);
    this.faqSection = this.faqSection.bind(this);
    this.subscribeToPlan = this.subscribeToPlan.bind(this);
    this.displayViewBasedOnWindowWidth =
      this.displayViewBasedOnWindowWidth.bind(this);
    this.learnMoreDrawer = this.learnMoreDrawer.bind(this);
    this.fullSizePopup = this.fullSizePopup.bind(this);
    this.smallSizePopup = this.smallSizePopup.bind(this);
    this.laterAndLearnMore = this.laterAndLearnMore.bind(this);
    this.additionalInfoList = this.additionalInfoList.bind(this);
    this.additionalInfoGrids = this.additionalInfoGrids.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchSubscriptionPlans = this.fetchSubscriptionPlans.bind(this);
    this.selectTier = this.selectTier.bind(this);
    this.createCartAndApplySubscription =
      this.createCartAndApplySubscription.bind(this);
    this.createAddressAndCart = this.createAddressAndCart.bind(this);
    this.renderPlanDisclaimer = this.renderPlanDisclaimer.bind(this);
    this.handleLoginClick = this.handleLoginClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });

    // Only fetch subscription plans for logged-in users
    const loggedIn = get(this.props, "client.loggedIn", false);
    if (loggedIn && isEmpty(this.state.subscriptionPlans)) {
      this.fetchSubscriptionPlans();
    }

    const soothePassObj = get(
      this.props,
      "booking.cart.info_fields.soothe_pass",
      null
    );
    const alreadyAppliedToCart = get(
      this.props,
      "booking.cart.info_fields.soothe_pass.subscription_applied_to_cart",
      false
    );
    const subscription_membership_ends_date = get(
      this.props,
      "client.soothe_pass.subscription_membership_ends_date",
      ""
    );
    if (
      soothePassObj &&
      soothePassObj.available &&
      !alreadyAppliedToCart &&
      !soothePassObj.subscribed &&
      !subscription_membership_ends_date
    ) {
      const subscription_tier_id = get(
        this.props,
        "booking.cart.info_fields.soothe_pass.subscription_tier_id",
        null
      );
      const subscription_tier_name = get(
        this.props,
        "booking.cart.info_fields.soothe_pass.subscription_tier_name",
        null
      );
      if (this.state.width > 1100) {
        seMembershipUpsellView(
          subscription_tier_name,
          subscription_tier_id,
          "booking_23_variant",
          get(this.props, "booking.cart.address.market", "")
        );
        seMembershipView(subscription_tier_name, subscription_tier_id);
      } else if (this.state.showSmallSizeModal) {
        seMembershipView(subscription_tier_name, subscription_tier_id);
      } else {
        seMembershipUpsellView(
          subscription_tier_name,
          subscription_tier_id,
          "booking_23_variant",
          get(this.props, "booking.cart.address.market", "")
        );
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Fetch subscription plans when user logs in
    const prevLoggedIn = get(prevProps, "client.loggedIn", false);
    const currentLoggedIn = get(this.props, "client.loggedIn", false);
    const isSubscribed = get(this.props, "client.soothe_pass.soothe_pass_subscribed", false);
    
    if (!prevLoggedIn && currentLoggedIn) {
      // User just logged in
      if (isSubscribed) {
        // User is already a SoothePass member - close popup and show ineligibility message
        this.setState({
          error: "You're already a SoothePass™ member! Your membership benefits are active.",
          showErrorModal: true,
        });
        // Close the popup after a short delay to allow user to read the message
        setTimeout(() => {
          this.props.showHideModal(false);
        }, 3000);
      } else if (isEmpty(this.state.subscriptionPlans)) {
        // User is not subscribed, fetch plans
        this.fetchSubscriptionPlans();
      }
    }
  }

  fetchSubscriptionPlans() {
    const zipCode = get(this.props, "booking.cart.address.zip_code", "");
    if (!zipCode) {
      this.setState({ error: "No zip code available", showErrorModal: true });
      return;
    }

    this.setState({ loadingPlans: true });
    soothe_pass_subscriptions(
      {zip_code:zipCode},
      (response) => {
        this.setState({
          loadingPlans: false,
          subscriptionPlans: response.data.subscription_tiers || [],
        });
      },
      (error) => {
        this.setState({
          loadingPlans: false,
          error: get(
            error,
            "response.data.errors.0.message",
            defaultErrorMessage
          ),
          showErrorModal: true,
        });
      }
    );
  }

  selectTier(tier) {
    this.setState({ selectedTier: tier });
  }

  subscribeToPlan() {
    const { selectedTier } = this.state;

    if (!selectedTier) {
      this.setState({
        error: "Please select a plan first",
        showErrorModal: true,
      });
      return;
    }

    this.createCartAndApplySubscription(selectedTier);
  }

  createCartAndApplySubscription(selectedTier) {
    const cartId = get(this.props, "booking.cart.id", "");
    const addressId = get(this.props, "booking.cart.address.id", "");
    const address = get(this.props, "booking.cart.address", null);

    if (cartId) {
      // Cart exists, apply subscription directly
      this.applySubscriptionToCart(cartId, selectedTier);
    } else if (addressId) {
      // No cart but have address, create cart first
      createCart(
        addressId,
        get(this.props, "fieldsHolder.csrfToken", ""),
        (response) => {
          const newCartId = get(response, "data.cart.id", "");
          // Preserve existing product, currentOption, and other important state when updating cart
          this.props.setCart({ 
            cart: decode(response.data.cart),
            product: get(this.props, "booking.product"),
            currentOption: get(this.props, "booking.currentOption"),
            addressId: get(this.props, "booking.addressId")
          });
          this.applySubscriptionToCart(newCartId, selectedTier);
        },
        (err) => {
          this.setState({
            error: get(
              err,
              "response.data.errors.0.message",
              defaultErrorMessage
            ),
            showErrorModal: true,
          });
        }
      );
    } else if (address && !isEmpty(address)) {
      // No cart and no address ID, but address data exists - create address first, then cart
      this.createAddressAndCart(address, selectedTier);
    } else {
      this.setState({
        error: "No address available. Please select an address first.",
        showErrorModal: true,
      });
    }
  }

  createAddressAndCart(address, selectedTier) {
    createAddress(
      address,
      (response) => {
        const newAddressId = get(response, "data.address.id", "");
        if (newAddressId) {
          // Update the cart state with the new address
          const cart = get(this.props, "booking.cart", {});
          this.props.setCart({
            cart: {
              ...cart,
              address: { ...address, id: newAddressId },
            },
            product: get(this.props, "booking.product"),
            currentOption: get(this.props, "booking.currentOption"),
            addressId: newAddressId
          });

          // Now create cart with the new address ID
          createCart(
            newAddressId,
            get(this.props, "fieldsHolder.csrfToken", ""),
            (cartResponse) => {
              const newCartId = get(cartResponse, "data.cart.id", "");
              // Preserve existing product, currentOption, and other important state when updating cart
              this.props.setCart({ 
                cart: decode(cartResponse.data.cart),
                product: get(this.props, "booking.product"),
                currentOption: get(this.props, "booking.currentOption"),
                addressId: newAddressId
              });
              this.applySubscriptionToCart(newCartId, selectedTier);
            },
            (err) => {
              this.setState({
                error: get(
                  err,
                  "response.data.errors.0.message",
                  defaultErrorMessage
                ),
                showErrorModal: true,
              });
            }
          );
        } else {
          this.setState({
            error: "Failed to create address.",
            showErrorModal: true,
          });
        }
      },
      (err) => {
        this.setState({
          error: get(
            err,
            "response.data.errors.0.message",
            defaultErrorMessage
          ),
          showErrorModal: true,
        });
      }
    );
  }

  applySubscriptionToCart(cartId, selectedTier) {
    const selectedPlan = get(selectedTier, "plan");
    // NOTE: Subscription does NOT create a cart_product entry - it applies subscription metadata
    // directly to the cart object. The subscription appears in cart.info_fields.soothe_pass
    // and affects pricing display but doesn't add a separate cart product item.
    applySubscription(
      cartId,
      { soothe_subscription_tier_id: selectedPlan?.id },
      (response) => {
        seMembershipContinue(selectedPlan?.name, selectedPlan?.id);
        // Preserve existing product, currentOption, and other important state when updating cart
        this.props.setCart({ 
          cart: decode(response.data.cart),
          product: get(this.props, "booking.product"),
          currentOption: get(this.props, "booking.currentOption"),
          addressId: get(this.props, "booking.addressId")
        });
        this.props.showHideModal(false);
        // Note: Removed auto-progression to next step - user stays on current step after adding subscription
      },
      (err) => {
        this.setState({
          error: get(
            err,
            "response.data.errors.0.message",
            defaultErrorMessage
          ),
          showErrorModal: true,
        });
      }
    );
  }

  closeModal() {
    const { selectedTier } = this.state;
    const selectedPlan = get(selectedTier, "plan");
    seMembershipSkip(selectedPlan?.name || "", selectedPlan?.id || "");
    this.props.setAlreadyShownSoothePassPopup(true);
    this.props.showHideModal(false);
  }

  handleLoginClick() {
    // Close the subscription popup and trigger login with subscription flag
    this.props.showHideModal(false);
    // Trigger the login for subscription handler from parent component
    if (this.props.onLoginClick) {
      this.props.onLoginClick();
    }
  }

  popupHeader(addBg = false, showPlanSelection = false, toaster = false) {
    const { has_discount, service_text } = get(
      this.props,
      "client.soothe_pass.discount",
      {}
    );
    return (
      <div
        className={`soothepass-popup-header ${addBg ? "with-background" : ""}`}
      >
        {this.state.width > 1100 ? (
          <div className="header-close-button">
            <a
              className="close-button"
              onClick={() => {
                this.closeModal();
              }}
              id="closeSubscriptionPopup"
            >
              <Close style={{ color: "#000000", fontSize: "24px" }} />
            </a>
          </div>
        ) : null}
        <div className="header-content">
          <div
            className={`header-title ${
              this.state.width > 1100 ? "" : "txt-left"
            }`}
          >
            {toaster
              ? "Limited Time Offer!"
              : showPlanSelection
              ? "Choose your plan"
              : "Unlock SoothePass™"}
          </div>
          {has_discount && (
            <div
              className={`header-offer ${
                this.state.width > 1100
                  ? ""
                  : "with-background-pink p-16 br-rd-8 txt-left"
              }`}
            >
              {!toaster && (
                <div className="offer-badge">
                  <span className="offer-badge-text">Limited Time Offer:</span>
                </div>
              )}
              <div className="offer-text">
                {service_text}
                {toaster && <div>Discount applied on checkout.</div>}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  planSelectionSection() {
    const { subscriptionPlans, selectedTier, loadingPlans } = this.state;

    if (loadingPlans) {
      return (
        <div className="plan-selection-loading">
          <div className="loading-spinner">Loading plans...</div>
        </div>
      );
    }

    if (isEmpty(subscriptionPlans)) {
      return (
        <div className="plan-selection-error">
          <div className="error-message">No subscription plans available</div>
        </div>
      );
    }

    return (
      <div className={`plan-selection-section `}>
        <div className="plan-options">
          {map(subscriptionPlans, (tier, index) => (
            <div
              key={get(tier, "plan.id", index)}
              className={`plan-card ${
                selectedTier?.plan?.id === get(tier, "plan.id")
                  ? "selected"
                  : ""
              }`}
              onClick={() => this.selectTier(tier)}
              style={{
                margin: "0px",
              }}
            >
              <div className="plan-content">
                <div className="plan-info">
                  <div className="plan-header">
                    <div className="plan-name-2">{get(tier, "plan.name")}</div>
                    <div className="plan-points">
                      {get(tier, "points")} points
                    </div>
                  </div>
                  <div className="plan-description">
                    {get(tier, "plan.description")}
                  </div>
                </div>
                <div className="plan-pricing">
                  <span className="price-amount">
                    {get(tier, "price.value", "0").toString().includes(",")
                      ? get(tier, "price.value")
                      : get(tier, "price.value") + ".00"}
                  </span>
                  <span className="price-period">
                    {get(tier, "price.per_period_brief")}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {this.renderPlanDisclaimer()}
      </div>
    );
  }

  renderPlanDisclaimer() {
    const { selectedTier, width } = this.state;
    
    // Get fine_print from the selected tier's price object
    const finePrint = get(selectedTier, "price.fine_print", "");
    
    if (!finePrint) {
      return null;
    }
    
    // Add responsive classes based on screen width
    const responsiveClass = width <= 800 ? "mobile-small" : width <= 1100 ? "mobile" : "desktop";
    
    return (
      <div className={`plan-disclaimer ${responsiveClass}`}>
        *{finePrint}
      </div>
    );
  }

  additionalInfoList() {
    return (
      <div className="additional-info-list">
        {map(ADDITIONAL_INFO, (info, it) => (
          <div key={`list-info-${it}`} className="info-item">
            {it % 2 === 0 ? null : (
              <div>
                <img className="" src={info.imgSrc} alt={info.title} />
              </div>
            )}
            <div className="info-content">
              <div className="info-title">{info.title}</div>
              <div className="info-description">{info.description}</div>
            </div>
            {it % 2 === 0 ? (
              <div>
                <img className="" src={info.imgSrc} alt={info.title} />
              </div>
            ) : null}
          </div>
        ))}
      </div>
    );
  }

  additionalInfoGrids() {
    const isFullSize = Boolean(this.state.width > 1100);
    return (
      <div className={`additional-info-grids ${isFullSize ? "full-size" : ""}`}>
        {map(ADDITIONAL_INFO, (info, it) => (
          <div
            key={`info-${it}`}
            className={`info-grid-item ${isFullSize ? "col-sm-3" : "col-md-6"}`}
          >
            <div className="info-icon">
              <img src={info.imgSrc} alt={info.title} />
            </div>
            <div className="info-title">{info.title}</div>
            <div className="info-description">{info.description}</div>
          </div>
        ))}
      </div>
    );
  }

  additionalInfo() {
    if (this.state.width > 800) {
      return this.additionalInfoGrids();
    }
    return this.additionalInfoList();
  }

  popupFooter(showPlanSelection = false) {
    const { selectedTier } = this.state;
    const loggedIn = get(this.props, "client.loggedIn", false);

    if (showPlanSelection) {
      return (
        <div className="popup-footer">
          <div className="selected-plan-info">
            {selectedTier && (
              <div className="plan-summary">
                <div className="plan-name">
                  {selectedTier?.plan?.name} plan, {selectedTier?.points} points
                </div>
                <div className="plan-price">
                  {(selectedTier?.price?.value).toString().includes(",")
                    ? selectedTier?.price?.value
                    : selectedTier?.price?.value + ".00"}
                  {selectedTier?.price?.per_period_brief}
                </div>
              </div>
            )}
          </div>
          <button
            className="btn cta-primary width-auto"
            onClick={() => {
              this.subscribeToPlan();
            }}
            id="addToCartButton"
          >
            Add to cart
          </button>
        </div>
      );
    }

    return (
      <div className="popup-footer">
        <button
          className={`btn cta-primary ${this.state.width > 1100 ? "width-auto " : "w-100-perc"}`}
          onClick={() => {
            if (!loggedIn) {
              this.handleLoginClick();
            } else {
              this.setState({ showPlanSelection: true });
            }
          }}
          id={loggedIn ? "chooseYourPlanButton" : "loginOrSignupButton"}
        >
          {loggedIn ? "Choose your plan" : "Login or signup"}
        </button>
      </div>
    );
  }

  faqSection() {
    const { openedIndex, subscriptionPlans } = this.state;
    const faq = get(this.props, "client.soothe_pass.faq", []);
    const loggedIn = get(this.props, "client.loggedIn", false);
    const { has_discount } = get(this.props, "client.soothe_pass.discount", {});
    
    // Determine fine print text based on user state
    let finePrintText = "";
    if (!loggedIn) {
      // Non-logged in users: show generic text
      finePrintText = "*Offer valid for new SoothePass® customers only. Offer is non-transferable, has no cash value, and may not be combined with any other promotions, discounts, or offers. Limit one offer per customer. Soothe reserves the right to modify or cancel this promotion at any time without notice. Additional terms and conditions may apply.";
    } else if (has_discount && !isEmpty(subscriptionPlans)) {
      // Logged in with discount: show fine print from first tier
      finePrintText = get(subscriptionPlans, "0.price.fine_print", "");
    }
    // Logged in without discount: no fine print (finePrintText remains empty)
    
    return (
      <div className="faq-section">
        {!isEmpty(faq) && (
          <>
            <div className="faq-title">Frequently asked questions</div>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              className="faq-list"
            >
              {faq.map((doc, ind) => (
                <div key={ind}>
                  <ListItem
                    button
                    key={`question-${ind}`}
                    onClick={() => {
                      if (openedIndex === ind) {
                        this.setState({ openedIndex: -1 });
                      } else {
                        if (openedIndex === null) {
                          const subscription_tier_id = get(
                            this.props,
                            "booking.cart.info_fields.soothe_pass.subscription_tier_id",
                            null
                          );
                          const subscription_tier_name = get(
                            this.props,
                            "booking.cart.info_fields.soothe_pass.subscription_tier_name",
                            null
                          );
                          seViewSoothePassFAQ(
                            subscription_tier_name,
                            subscription_tier_id
                          );
                        }
                        this.setState({ openedIndex: ind });
                      }
                    }}
                    className="faq-item"
                  >
                    <ListItemText primary={doc.question} />
                    {openedIndex === ind ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse
                    key={`collapse-${ind}`}
                    in={openedIndex === ind}
                    timeout="auto"
                    unmountOnExit
                    className="faq-collapse"
                  >
                    {doc.answer}
                  </Collapse>
                  <Divider />
                </div>
              ))}
            </List>
          </>
        )}
        {finePrintText && (
          <div className="faq-fine-print">
            {finePrintText}
          </div>
        )}
      </div>
    );
  }

  smallSizePopup() {
    const { showPlanSelection } = this.state;
    const { has_discount, service_text } = get(
      this.props,
      "client.soothe_pass.discount",
      {}
    );

    if (this.state.showSmallSizeModal) {
      return (
        <div className="mimic-modal-wrapper">
          <div
            className="mimic-modal-content soothepass-modal"
            id="subscriptionPopup"
          >
            <div className="modal-header">
              <div
                className="header-title"
                style={{ flex: "1 1", textAlign: "center" }}
              >
                SoothePass™
              </div>
              <div style={{ marginLeft: "auto" }}>
                <a
                  className="close-button"
                  onClick={() => {
                    this.setState({ showSmallSizeModal: false });
                    this.closeModal();
                  }}
                >
                  <Close style={{ color: "#000000", fontSize: "24px" }} />
                </a>
              </div>
            </div>
            <div className={`modal-body `}>
              <div
                className={`modal-content p-0-imp ${
                  showPlanSelection ? "with-background-pink" : ""
                }`}
                style={showPlanSelection ? {
                  borderRadius: "0px!important",
                  paddingBottom: "116px!important",
                } : {}}
              >
                <div className={`soothepass-popup-header`}>
                  {this.state.width > 1100 ? (
                    <div className="header-close-button">
                      <a
                        className="close-button"
                        onClick={() => {
                          this.closeModal();
                        }}
                        id="closeSubscriptionPopup"
                      >
                        <Close style={{ color: "#000000", fontSize: "24px" }} />
                      </a>
                    </div>
                  ) : null}
                  <div className={`header-content`}>
                    <div
                      className={`header-title ${
                        this.state.width > 1100 ? "" : "txt-left"
                      }`}
                    >
                      {showPlanSelection
                        ? "Choose your plan"
                        : "Unlock SoothePass™"}
                    </div>
                    {has_discount && (
                      <div
                        className={`header-offer ${
                          showPlanSelection
                            ? "txt-left"
                            : "with-background-pink p-16 br-rd-8 txt-left"
                        }`}
                      >
                        {!showPlanSelection && (
                          <div className="offer-badge">
                            <span className="offer-badge-text">
                              Limited Time Offer:
                            </span>
                          </div>
                        )}
                        <div className="offer-text">
                          {service_text}
                          <div>Discount applied on checkout.</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {showPlanSelection ? (
                  this.planSelectionSection()
                ) : (
                  <>
                    {this.additionalInfo()}
                    {this.faqSection()}
                  </>
                )}
                {this.popupFooter(showPlanSelection)}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  laterAndLearnMore() {
    const loggedIn = get(this.props, "client.loggedIn", false);
    
    return (
      <div className="later-learn-more">
        <button
          type="button"
          className="btn maybe-later-btn"
          onClick={() => {
            this.closeModal();
            this.props.goToNextStep();
          }}
        >
          Maybe later
        </button>
        <button
          type="button"
          className="btn learn-more-btn"
          onClick={() => {
            if (!loggedIn) {
              this.handleLoginClick();
            } else {
              const subscription_tier_id = get(
                this.props,
                "booking.cart.info_fields.soothe_pass.subscription_tier_id",
                null
              );
              const subscription_tier_name = get(
                this.props,
                "booking.cart.info_fields.soothe_pass.subscription_tier_name",
                null
              );
              seMembershipView(subscription_tier_name, subscription_tier_id);
              this.setState({ showPlanSelection: true });
            }
          }}
        >
          Learn more
        </button>
      </div>
    );
  }

  learnMoreDrawer() {
    const { showPlanSelection } = this.state;

    return (
      <div>
        <Drawer
          style={{ zIndex: 999999999999 }}
          anchor="bottom"
          open={!this.state.showSmallSizeModal}
          onClose={() => {
            this.closeModal();
          }}
          // Prevent modal backdrop clicks from propagating to underlying components
          ModalProps={{
            disableBackdropClick: true,
            disableEscapeKeyDown: false,
            // Ensure modal doesn't interfere with other drawers
            keepMounted: false,
            style: { zIndex: 999999999999 }
          }}
          // Disable swipe to prevent gesture conflicts with modality drawer
          disableSwipeToOpen={true}
        >
          <div
            className={`soothepass-drawer ${
              showPlanSelection
                ? "plan-selection-drawer with-background-pink"
                : ""
            }`}
          >
            {this.popupHeader(false, showPlanSelection, true)}
            {showPlanSelection ? (
              <div className="drawer-content">
                {this.planSelectionSection()}
                {this.popupFooter(showPlanSelection)}
              </div>
            ) : (
              this.laterAndLearnMore()
            )}
          </div>
        </Drawer>
        {this.smallSizePopup()}
      </div>
    );
  }

  fullSizePopup() {
    const { showPlanSelection } = this.state;
    const soothePassObj = get(
      this.props,
      "booking.cart.info_fields.soothe_pass",
      null
    );

    if (showPlanSelection) {
      return (
        <div className="mimic-modal-wrapper">
          <div className="mimic-modal-content soothepass-modal">
            {this.popupHeader(true, true)}
            <div className="modal-content p-0-imp">{this.planSelectionSection()}</div>
            {this.popupFooter(true)}
          </div>
        </div>
      );
    }

    return (
      <div className="mimic-modal-wrapper">
        <div className="mimic-modal-content soothepass-modal">
          {this.popupHeader(true)}
          <div className="modal-content p-0-imp">
            {this.additionalInfo()}
            <div className="modal-sections">
              <div className="section-left">{this.faqSection()}</div>
            </div>
          </div>
          {this.popupFooter()}
        </div>
      </div>
    );
  }

  displayViewBasedOnWindowWidth() {
    if (this.state.width < 1100) {
      return this.learnMoreDrawer();
    }
    return this.fullSizePopup();
  }

  errorModal() {
    return (
      <ErrorModal
        isOpen={this.state.showErrorModal}
        close={() => {
          this.setState({ showErrorModal: false, error: "" });
        }}
      >
        <p>{this.state.error}</p>
      </ErrorModal>
    );
  }

  render() {
    const isSubscriptionAvailable = get(
      this.props,
      "client.soothe_pass.soothe_pass_available",
      false
    );
    const loggedIn = get(this.props, "client.loggedIn", false);
    
    // Always show error modal if it's open, regardless of subscription availability
    if (this.state.showErrorModal) {
      return this.errorModal();
    }
    
    // For logged-in users, check subscription availability
    // For anonymous users, allow popup to show (they can see banner, so SoothePass is available)
    if (!loggedIn || isSubscriptionAvailable) {
      return (
        <>
          {this.displayViewBasedOnWindowWidth()}
          {this.errorModal()}
        </>
      );
    }
    
    return null;
  }
}
const mapStateToProps = (state) => ({
  booking: state.booking,
  bookingFlow: state.bookingFlow,
  client: state.client,
  fieldsHolder: state.fieldsHolder,
});

export default withLocalize(
  connect(mapStateToProps, {
    setAlreadyShownSoothePassPopup,
    setCart,
  })(SubscriptionPlanPopup)
);
